import { useQuery } from "react-query";
import getVirtualAccountsTransactions, {
  VirtualAccountTransactionsResponse,
} from "../services/getVirtualAccountsTransactions";
import { MRT_PaginationState } from "mantine-react-table";
function useGetVATransactionsMutation(
  token: string,
  pagination: MRT_PaginationState,
  startDate: string,
  endDate: string
) {
  return useQuery<VirtualAccountTransactionsResponse>({
    queryKey: ["get-vatransactions", pagination, startDate, endDate], //refetch whenever the URL changes (pagination or monthsFilter)
    queryFn: () =>
      getVirtualAccountsTransactions({
        token,
        pagination,
        startDate,
        endDate,
      }),
    retry: false,
    keepPreviousData: true, //useful for paginated queries by keeping data from previous pages on screen while fetching the next page
  });
}

export default useGetVATransactionsMutation;
